import BaseClass from "../BaseClass";
import Timer from "../utils/Timer";
import NotificationModal from "./NotificationModal";
import TimerModal from "./TimerModal";

const defaultOptions = {};

/**
 * This class is used for handling modals.
 */
export default class ModalsWrapper extends BaseClass {

  constructor(options) {
    super(options, defaultOptions);

    this.init();
  }

  init() {
    $(document).ready(() => {
      let midnightRefreshModal = new TimerModal('[data-modal-timer="midnight"]', Timer.compareDays, 1);
      midnightRefreshModal.initModal();

      let dataRefreshModal = new TimerModal('[data-modal-timer="outdated-check"]', Timer.compareMinutes, 120);
      dataRefreshModal.initModal();

      let reservationRefreshModal = new TimerModal('[data-modal-timer="reservation-timer"]', Timer.compareMinutes, 20, TimerModal.onCloseGoBack);
      reservationRefreshModal.initModal();

      let dataValidatedModal = new NotificationModal('[data-modal-notification="data-validated"]');
      if(dataValidatedModal.canFire()) dataValidatedModal.initModal();
    });
  }
}
